import {Navigate} from 'react-router-dom';
import {useAuth} from '@/contexts/AuthContext';

interface RequireAdminProps {
    children: React.ReactNode;
}

export function RequireAdmin({children}: RequireAdminProps) {
    const {user, isAuthenticated, isLoading} = useAuth();

    if (isLoading) {
        return (
            <div className="flex min-h-screen items-center justify-center">
                <div className="size-12 animate-spin rounded-full border-b-2 border-gray-900"></div>
            </div>
        );
    }

    if (!isAuthenticated) {
        return <Navigate to="/login" replace />;
    }

    if (user?.role !== 'superadmin') {
        return <Navigate to="/dashboard" replace />;
    }

    return <>{children}</>;
}
